import React, { useState } from "react";
import { Col, Row, Card, Badge, Spinner } from "react-bootstrap";
import { selectAlertStatus } from "./../../ShareFunction";
import SplitNumber from "../../../components/SplitNumber";
import LazyLoad from "react-lazyload";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import ApiBasket from "../../../../core/api/api.basket";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import _ from "lodash";

import {
  IconCalendar,
  IconGift,
  IconLocation,
  IconPaper,
  IconTooman,
} from "../../../../assets/icons";

function CardOrderDetail({ item, index, basket, callBack }) {
  const [isImageLoad, setIsImageLoad] = useState(false);
  const [loading, setLoading] = useState([]); // روی دکمه ثبت

  const handleModalCancle = (item) => {
    callBack(item);
  };
  const handleDownloadFile = (item) => async (event) => {
    try {
      setLoading({ itemId: item.id, state: true });
      let obj = {
        id: item.basketItemId,
        fileId: item.id,
        access: 2,
      };
      let rest = await ApiBasket.getFile(obj).then((response) => {
        if (response.type == "text/plain") {
          let myblob = new Blob([response]);
          myblob.text().then((text) => {
            // toast.configure();
            toast(text, { position: "top-right" });
          });
        } else {
          const fileBlobUrl = URL.createObjectURL(new Blob([response]));

          const anchor = document.createElement("a");
          anchor.style.display = "none";
          anchor.id = item.fileName + Math.floor(Math.random() * 100);
          anchor.href = fileBlobUrl;
          anchor.download = item.fileName;
          document.body.appendChild(anchor);
          anchor.click();
        }
      });
    } catch (error) {
    } finally {
      setLoading({ itemId: item.id, state: false });
    }
  };
  const disabledButton = (i) => {
    if (i == 1)
      return {
        pointerEvents: "none",
        opacity: 0.7,
      };
    else
      return {
        pointerEvents: "initial",
        opacity: 1,
      };
  };
  const itemStatus = selectAlertStatus(item);
  const getBasketITemDetailForDisplay = function (details) {
    let showDetails = "";
    if (!_.isEmpty(details)) {
      JSON.parse(details)?.map((item, index) => {
        if (_.isEmpty(showDetails)) showDetails += item.text;
        else showDetails += " - <span class='fw-bold'>" + item.text + "</span>";
      });
    }
    return showDetails;
  };
  return (
    <>
      {/* <ToastContainer position="top-right" rtl="true"></ToastContainer> */}
      <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
        <Card key={index} className="w-100  rounded-3 mb-3 shadow-sm ">
          <Card.Body>
            <Row>
              <Col xs={12}>
                <Row>
                  <Col xs="auto" className="position-relative">
                    {isImageLoad && (
                      <div
                        className="position-absolute rounded-pill bg-danger badge fw-normal fs-065"
                        style={{ top: "-6px" }}
                      >
                        {Math.round(
                          (1 - item.price / item.originalPrice) * 100
                        )}
                        %
                      </div>
                    )}

                    <img
                      height={!isImageLoad ? 0 : ""}
                      onLoad={() => {
                        setIsImageLoad(true);
                      }}
                      src={
                        process.env.REACT_APP_API_URL +
                        item.amusementServiceImageUrl
                      }
                      className="img-fluid rounded-2"
                      width={!isImageLoad ? 0 : 80}
                      alt="تفریح "
                    />
                    {!isImageLoad && (
                      <Skeleton width={80} height={47} className="mt-0" />
                    )}
                  </Col>
                  <Col className="ps-0 my-auto" style={{ lineHeight: "19px" }}>
                    <div className="fw-bold mb-1">
                      {item.amusementServiceName}
                    </div>
                    <div className="text-muted small-svg">
                      <div
                        className=" fs-065 "
                        dangerouslySetInnerHTML={{
                          __html: getBasketITemDetailForDisplay(item.details),
                        }}
                      />
                    </div>
                    {item.originalPrice - item.price > 0 && (
                      <div className="fs-065 text-danger">
                        <SplitNumber
                          number={item.originalPrice - item.price}
                        ></SplitNumber>
                        <span className="ps-1">تخفیف</span>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} className="border-top pt-2 mx-0 mt-2">
                    <Row className="my-2">
                      <Col xs="auto" className="pe-0 text-muted">
                        تاریخ استفاده از تفریح
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark ">
                        {item.checkInDate}
                      </Col>
                    </Row>

                    <Row className="my-2">
                      <Col xs="auto" className="pe-0 text-muted">
                        مبلغ آیتم
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark medium-svg">
                        <SplitNumber number={item.price}></SplitNumber>
                        <span>
                          <IconTooman
                            fillColor="#000"
                            style={{ marginTop: "-7px" }}
                          />
                        </span>
                      </Col>
                    </Row>

                    <Row className="my-2">
                      <Col xs="auto" className="pe-0 text-muted">
                        تعداد بلیط
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark ">
                        {item.totalCount} عدد
                      </Col>
                    </Row>
                    <Row className="my-2">
                      <Col xs="auto" className="pe-0 text-muted">
                        مبلغ کل{" "}
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark medium-svg">
                        <SplitNumber
                          number={item.price * item.totalCount}
                        ></SplitNumber>
                        <span>
                          <IconTooman
                            fillColor="#000"
                            style={{ marginTop: "-7px" }}
                          />
                        </span>
                      </Col>
                    </Row>

                    <Row className="my-2">
                      <Col xs="auto" className="pe-0 text-muted">
                        وضعیت
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end">
                        <span className="ps-1 text-danger  ">
                          {item.isDeleted
                            ? "حذف شده"
                            : item.isExpire
                            ? "منقضی شده"
                            : item.isFullCapacity
                            ? "ظرفیت تکمیل"
                            : itemStatus.text}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className="border-top-0 bg-light-1">
            <div className="d-flex flex-wrap  align-items-center">
              {basket?.status === 1 && itemStatus.showCancelButton && (
                <div
                  className="text-center bg-light-danger btn btn-outline-danger px-2 py-1  fs-075  cursor-pointer me-1"
                  onClick={() => {
                    handleModalCancle(item);
                  }}
                >
                  درخواست کنسلی
                </div>
              )}
              {item?.amusementServiceReserveItemIssueTicketType == 2 &&
                itemStatus.showDownloadButton && (
                  <Link
                    className="text-center me-1 my-1 btn btn-primary fs-075  px-2 py-1 cursor-pointer"
                    target="_blank"
                    to={`/ticket/${item.id}`}
                  >
                    {" "}
                    دانلود بلیط
                  </Link>
                )}
              {item?.itemFiles?.map((element) => (
                <div
                  style={
                    loading.itemId == element.id && loading.state == true
                      ? disabledButton(1)
                      : disabledButton(0)
                  }
                  className="text-center me-1 my-1 btn btn-primary fs-075  px-2 py-1 cursor-pointer"
                  onClick={handleDownloadFile(element)}
                >
                  {loading.itemId == element.id && loading.state == true
                    ? "آماده سازی جهت دانلود"
                    : "دانلود بلیط"}
                  <span>&nbsp;</span>
                  {loading.itemId == element.id && loading.state == true && (
                    <Spinner animation="border" variant="warning" size="sm" />
                  )}
                </div>
              ))}
            </div>
          </Card.Footer>
        </Card>
      </SkeletonTheme>
    </>
  );
}

export default CardOrderDetail;
